import React from 'react';
import { Gift, Sparkles } from 'lucide-react';
export function GuaranteeBox() {
  return <div className="bg-gradient-to-br from-[#D4AF37]/10 to-[#E8DCC4]/30 border-2 border-[#D4AF37] rounded-xl p-8 text-center" data-id="element-31">
      <div className="inline-flex items-center justify-center w-20 h-20 bg-[#D4AF37] rounded-full mb-6" data-id="element-32">
        <Gift className="w-10 h-10 text-white" data-id="element-33" />
      </div>

      <h3 className="text-2xl md:text-3xl font-bold text-[#8B7355] mb-4 flex items-center justify-center gap-2" data-id="element-34">
        <Sparkles className="w-6 h-6 text-[#D4AF37]" data-id="element-35" />
        BONO GRATIS INCLUIDO
      </h3>

      <h4 className="text-xl md:text-2xl font-semibold text-[#D4AF37] mb-6" data-id="element-36">
        21 Recetas de Limpieza Express en 5 Minutos
      </h4>

      <div className="mb-8" data-id="element-37">
        <img src="https://cdn.magicpatterns.com/uploads/nNomRYwXd8DTXVZnCmLJ4x/21recetas-express-colorcrema.png" alt="21 Recetas de Limpieza Express" className="w-full max-w-lg mx-auto rounded-lg shadow-xl" data-id="element-38" />
      </div>

      <div className="text-left max-w-3xl mx-auto space-y-4" data-id="element-39">
        <p className="text-lg text-[#3A3226] leading-relaxed" data-id="element-40">
          Hija querida, este ebook,{' '}
          <span className="font-semibold" data-id="element-41">
            21 Recetas de Limpieza Express en 5 Minutos
          </span>
          , es mi manera de acompañarte cuando la casa se pone movida: cuando
          hay derrames, olores raros, manchas nuevas o esas visitas que llegan
          sin avisar. Todo con cosas sencillas que ya tienes en casa.
        </p>

        <p className="text-lg text-[#3A3226] leading-relaxed" data-id="element-42">
          En estas páginas te enseño 21 recetas rápidas y sin químicos fuertes.
          Son soluciones que funcionan en minutos y que te devuelven la calma
          cuando el caos quiere asomarse.
        </p>

        <p className="text-xl text-center font-semibold text-[#D4AF37] mt-6 italic" data-id="element-43">
          Mi niña, este es tu manual para salir de apuros sin estrés, sin gastar
          de más y con el cariño de siempre. Porque cuando la vida te sorprende…
          aquí estoy yo para salvarte en 5 minutos.
        </p>
      </div>
    </div>;
}